import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "../../../assets/Admin/table-data.scss";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";

import React, { Fragment, useEffect, useRef, useState } from "react";

import AddIcon from "@mui/icons-material/Add";
import { AgGridReact } from "ag-grid-react";
import { Button } from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";
import { Link } from "react-router-dom";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { agGridLocaleText } from "../../../agGridTranslations";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

//css

const AggridTable = (props) => {
  const {
    rowData,
    columnDefs,
    paginationPageSize = 20,
    rowHeight,
    buttonLink,
    buttonText,
    importButton = false,
    reloadData,
    onCellUpdate,
    gridStateKey = "aggrid",
  } = props || {};

  const gridRef = useRef();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [gridReady, setGridReady] = useState(false);
  const [activeFilters, setActiveFilters] = useState(0);

  const getLocaleText = (key) => t(`aggrid.${key}`);

  const defaultColDef = {
    sortable: true,
    resizable: true,
    pagination: true,
    floatingFilter: true,
    enableRowGroup: true,
    cellSelection: { handle: { mode: "range" } },
  };

  const [showImportModal, setShowImportModal] = useState(false);

  const toggleImportModal = () => setShowImportModal(!showImportModal);

  // Provera trenutne putanje i sakrivanje dugmeta ako je potrebno
  const currentPath = window.location.pathname;
  const shouldHideRefreshButton = currentPath === "/products-check";

  const handleCellValueChanged = (params) => {
    const { colDef, oldValue, newValue, data, node } = params;

    const field = colDef.field;
    // prosledi roditelju sve što mu treba (id, polje, nova/stara vrednost i node za eventualni revert)
    const dataValue = {
      id: data?.id,
      field,
      newValue,
      oldValue,
      rowData: data,
    };

    dispatch(onCellUpdate(dataValue));
  };

  // helper da radi i na v30- i na v31+
  const getApis = () => {
    const api = gridRef.current?.api;
    // u v31+ columnApi je uklonjen; sve metode su na api
    const columnApi = gridRef.current?.columnApi ?? api;
    return { api, columnApi };
  };

  const handleGridReady = (params) => {
    setGridReady(true);

    // 👇 pokušaj da učita prethodno sačuvano stanje
    const savedState = localStorage.getItem(`aggrid-state-${gridStateKey}`);
    if (!savedState) return;

    try {
      const { filterModel, columnState } = JSON.parse(savedState);
      const api = params.api;
      const columnApi = params.columnApi ?? params.api; // fallback za v31+

      // primeni filtere ako ih ima
      if (filterModel) {
        api.setFilterModel(filterModel);
        api.onFilterChanged();
      }

      // primeni stanje kolona (uključuje i sort i širine)
      if (columnState) {
        columnApi.applyColumnState({ state: columnState, applyOrder: true });
      }
    } catch (err) {
      console.warn("⚠️ Greška pri učitavanju stanja grida:", err);
    }
  };

  // kada se filter promeni, snimi trenutno stanje filtera u localStorage
  useEffect(() => {
    if (!gridReady || !gridRef.current) return;

    const { api, columnApi } = getApis();
    if (!api) return;

    const updateFilterCount = () => {
      if (!api || !columnApi) return;

      // broj aktivnih FILTERA
      const filterModel = api.getFilterModel() ?? {};
      const filterCount = Object.keys(filterModel).length;

      // broj aktivnih GRUPISANJA
      const rowGroupCount = columnApi.getRowGroupColumns().length;

      // ukupno (ili odvoji ako želiš)
      setActiveFilters(filterCount + rowGroupCount);
    };

    api.addEventListener("filterChanged", updateFilterCount);
    api.addEventListener("sortChanged", updateFilterCount);
    api.addEventListener("columnMoved", updateFilterCount);
    api.addEventListener("columnResized", updateFilterCount);
    api.addEventListener("columnVisible", updateFilterCount);
    api.addEventListener("columnPinned", updateFilterCount);
    api.addEventListener("columnRowGroupChanged", updateFilterCount);
    updateFilterCount();

    const saveGridState = () => {
      try {
        const filterModel = api.getFilterModel?.() ?? null;
        const columnState = columnApi?.getColumnState?.() ?? null;

        const state = { filterModel, columnState };
        localStorage.setItem(
          `aggrid-state-${gridStateKey}`,
          JSON.stringify(state)
        );
        // console.log("💾 Sačuvano stanje grida:", state);
      } catch (e) {
        console.warn("Nisam uspeo da sačuvam grid state:", e);
      }
    };

    api.addEventListener("filterChanged", saveGridState);
    api.addEventListener("sortChanged", saveGridState);
    api.addEventListener("columnMoved", saveGridState);
    api.addEventListener("columnResized", saveGridState);
    api.addEventListener("columnVisible", saveGridState);
    api.addEventListener("columnPinned", saveGridState);
    api.addEventListener("columnRowGroupChanged", saveGridState);

    return () => {
      api.removeEventListener("filterChanged", saveGridState);
      api.removeEventListener("sortChanged", saveGridState);
      api.removeEventListener("columnMoved", saveGridState);
      api.removeEventListener("columnResized", saveGridState);
      api.removeEventListener("columnVisible", saveGridState);
      api.removeEventListener("columnPinned", saveGridState);
      api.removeEventListener("columnRowGroupChanged", saveGridState);
    };
  }, [gridReady, gridStateKey]);

  const resetGridState = () => {
    const { api, columnApi } = getApis();
    if (!api || !columnApi) return;

    // 1️⃣ resetuj filtere
    api.setFilterModel(null);

    // 2️⃣ resetuj sortiranje i kolone
    columnApi.resetColumnState();

    // 3️⃣ obriši iz localStorage-a
    localStorage.removeItem(`aggrid-state-${gridStateKey}`);

    // 4️⃣ refreshuj prikaz
    api.onFilterChanged();
  };

  return (
    <Fragment>
      <div className="buttons-container-aggird w-100">
        <div className="active-filters-button">
          {activeFilters > 0 && (
            <div className="active-filters-button-title">
              Aktivni filteri ({activeFilters})
            </div>
          )}
        </div>
        <div className="d-flex align-items-center justify-content-end flex-wrap gap-1 gap-sm-3">
          {importButton && (
            <Fragment>
              <div className="button-export-to-excel">
                <Button
                  variant="contained"
                  size="small"
                  startIcon={<FileDownloadOutlinedIcon />}
                  onClick={toggleImportModal}
                >
                  {t("button.import")}
                </Button>
              </div>
            </Fragment>
          )}
          {buttonLink && (
            <div className="button-export-to-excel">
              <Link to={buttonLink}>
                <Button
                  variant="contained"
                  size="small"
                  className="button-color-submit"
                  startIcon={<AddIcon />}
                >
                  {buttonText}
                </Button>
              </Link>
            </div>
          )}
          <div className="button-export-to-excel">
            <Button
              variant="contained"
              size="small"
              color="warning"
              startIcon={<FileDownloadOutlinedIcon />}
              onClick={() => {
                gridRef.current.api.exportDataAsExcel({
                  onlySelected: false,
                  allColumns: true,
                  processCellCallback: (params) => params.value,
                });
              }}
            >
              {t("button.export_excel")}
            </Button>
          </div>
          <div className="button-export-to-excel">
            <Button
              variant="contained"
              size="small"
              color="info"
              startIcon={<CachedIcon />}
              onClick={reloadData}
            >
              {t("global.reload_data")}
            </Button>
          </div>
          <div className="button-export-to-excel">
            <Button
              style={{ backgroundColor: "rgb(107, 103, 214)" }}
              variant="contained"
              size="small"
              color="secondary"
              startIcon={<CachedIcon />} // možeš staviti drugi icon ako želiš
              onClick={resetGridState}
            >
              {t("global.clear_filters")} ({activeFilters})
            </Button>
          </div>
        </div>
      </div>
      <div className="table-grid-compontent-main ag-theme-alpine">
        <AgGridReact
          ref={gridRef}
          rowHeight={rowHeight}
          rowData={rowData}
          paginationPageSize={paginationPageSize}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          animateRows={true}
          pagination={true}
          groupDisplayType="multipleColumns"
          suppressRowTransform={true}
          rowGroupPanelShow="always"
          onGridReady={handleGridReady}
          onFirstDataRendered={(params) => {
            const savedState = localStorage.getItem(
              `aggrid-state-${gridStateKey}`
            );
            if (!savedState) return;
            const { filterModel } = JSON.parse(savedState);
            if (filterModel) {
              params.api.setFilterModel(filterModel);
              params.api.onFilterChanged();
            }
          }}
          enableRangeSelection={true}
          localeText={agGridLocaleText(getLocaleText)}
          onCellValueChanged={handleCellValueChanged}
          stopEditingWhenCellsLoseFocus={true}
          singleClickEdit={true}
        />
      </div>
    </Fragment>
  );
};

export default AggridTable;
